import countdown from "../helpers/countdown-library";

export default class Countdown {
    static init() {
        const wrapper = document.querySelector(".countdown-wrapper");
        if (!wrapper)
            return;
        
        const deadline = new Date(wrapper.dataset.countdownDate);
        const now = new Date();

        if(deadline < now)
            return;

        this.update(wrapper);

        let interval = setInterval(() => {
            if (this.update(wrapper))
                clearInterval(interval);
        }, 1000)
    }

    static update(wrapper) {
        const daysEl = wrapper.querySelector(".days");
        const hoursEl = wrapper.querySelector(".hours");
        const minutesEl = wrapper.querySelector(".minutes");
        const secondsEl = wrapper.querySelector(".seconds");

        const daysUntil = countdown(new Date(wrapper.dataset.countdownDate), null,
            countdown.DAYS|countdown.HOURS|countdown.MINUTES|countdown.SECONDS);

        daysEl.innerHTML = daysUntil.days;
        hoursEl.innerHTML =  daysUntil.hours;
        minutesEl.innerHTML = daysUntil.minutes;
        secondsEl.innerHTML = daysUntil.seconds;

        if (daysUntil.days == "0" && daysUntil.hours == "0" && daysUntil.minutes == "0" && daysUntil.seconds == "0") {
            return true;
        }
    }
}